import React from "react";
import Typography from "@material-ui/core/Typography";
const PurchaseOrder = ({}) => {
  return (
    <React.Fragment>
      <Typography paragraph variant="h4">
        Purchase Order
      </Typography>
      <Typography paragraph variant="h5">
        Make the purchase document based on company needs
      </Typography>
      <Typography paragraph variant="body1">
        Purchase Order is one of the features under the Procurement module to
        perform purchasing transactions particularly to handle purchase
        agreement as an indication that the purchase order is ready to be
        processed and fulfilled by the vendor. It contains any information
        regarding the vendor address & contact, currency & exchange rate used
        for the transaction, applied terms & conditions, and the purchase items
        detail.
      </Typography>
      <Typography paragraph variant="h5" className="mt-5">
        How it works
      </Typography>
      <Typography paragraph variant="body1">
        The first information displayed on this feature is the Purchase Order
        list. It is displayed like a table that contains download functions,
        sort, filter, and global search on the header area, and contains data
        navigation and refresh function on the footer area. The data column that
        appears in this table list are listed below:
      </Typography>
      <Typography paragraph variant="body1">
        <b>Purchase Order ID</b>
        <br />
        Indicates the ID of the Purchase Order.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Vendor Name</b>
        <br />
        Indicates the name of the Vendor.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Purchase Date</b>
        <br />
        Indicates the purchase date of the Purchase Order.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Goods Receive Status</b>
        <br />
        Indicates the goods receive status of the Purchase Order. There are 3
        statuses: Unreceived, Partially Received, and Fully Received.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Invoice Status</b>
        <br />
        Indicates the invoice status of the Purchase Order. There are 3
        statuses: Unbilled, Partially Billed, and Fully Billed.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Grand Total</b>
        <br />
        Indicates the grand total of the Purchase Order.
      </Typography>
      <Typography paragraph variant="body1">
        Apart from the column appearing on the table list, there are more
        columns available on each row by clicking the expand button on the left
        side of each data.
      </Typography>
      <Typography paragraph variant="body1">
        Besides, there are 3 buttons and 1 approval indicator that appear on
        each row of Purchase Order data with specific conditions explained
        below:
      </Typography>
      <Typography paragraph variant="body1">
        <b>Edit Purchase Order</b>
        <br />
        This button only appears if the Goods Receive status is 'Unreceived',
        the Invoice status is 'Unbilled', and the approval indicator is not
        'Document Waiting For Approval'. It is used to edit the Purchase Order
        data.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Purchase Order Detail</b>
        <br />
        This button is used to navigate to the Purchase Order detail which
        contains some tabs with details below:
        <ul>
          <li>
            <b>Basic Info</b> : This tab is to display the Purchase Order data.
          </li>
          <li>
            <b>Goods Received</b> : This tab is to display any Goods Received
            related to the Purchase Order.
          </li>
          <li>
            <b>A/P Invoices</b> : This tab is to display any A/P Invoices
            related to the Purchase Order.
          </li>
          <li>
            <b>Attachments</b> : This tab is to display any Attachments related
            to the Purchase Order.
          </li>
          <li>
            <b>Notes</b> : This tab is to display any Notes related to the
            Purchase Order.
          </li>
          <li>
            <b>PrintOut</b> : This tab is to display any PrintOut related to the
            Purchase Order.
          </li>
        </ul>
        When opening the Purchase Order detail, there will be 1 button appearing
        on the top section. The button is 'Edit Purchase Order' which is used to
        edit the Purchase Order data. The button only appears when the Goods
        Receive status is 'Unreceived', the Invoice status is 'Unbilled', and
        the approval indicator is not 'Document Waiting For Approval'.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Delete Purchase Order</b>
        <br />
        This button only appears if the Goods Receive status is 'Unreceived',
        the Invoice status is 'Unbilled', and the approval indicator is not
        'Document Waiting For Approval'. It is used to delete the Purchase Order
        data. The Purchase Order data is undeletable once it has relations with
        other documents.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Approval Indicator</b>
        <br />
        The Purchase Order document could have an approval flow if it is
        configured. The approval indicator appears as an icon after the document
        ID. There are 4 approval indicators: Document No Need Approval, Document
        Waiting For Approval, Document Approved, and Document Rejected.
      </Typography>
    </React.Fragment>
  );
};

export default PurchaseOrder;
